import React from 'react';
import { useHistory } from 'react-router';
import { useFormik } from 'formik';
import { Button, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from 'components/ConfirmDialog';
import { storeSitefConfig, updateSitefConfig } from './../services/sitefServices';
import SitefConfigFormProps from 'types/forms/SitefConfigFormProps';
import SitefConfigForm from './schemas/SitefConfigForm';

export default ({ config }: SitefConfigFormProps): JSX.Element => {
  const history = useHistory();
  const [openDialog, setOpenDialog] = React.useState(false);
  const { t } = useTranslation();

  const onConfirm = async (): Promise<void> => {
    try {
      const data = config
        ? await updateSitefConfig({ ...formik.values })
        : await storeSitefConfig({ ...formik.values });
      if (data) {
        history.push('/private/admin/payments/sitef');
      }
    } catch {
      formik.setSubmitting(false);
    }
  };

  const onCancel = (): void => {
    formik.setSubmitting(false);
  };

  const formik = useFormik({
    initialValues: {
      id: config?.id ?? '',
      description: config?.description ?? '',
      merchantId: config?.merchantId ?? '',
      merchantKey: config?.merchantKey ?? '',
    },
    validationSchema: SitefConfigForm(t),
    onSubmit: async () => {
      setOpenDialog(true);
    },
  });
  return (
    <div>
      <ConfirmDialog open={openDialog} setOpen={setOpenDialog} onConfirm={onConfirm} onCancel={onCancel} />
      <form onSubmit={formik.handleSubmit}>
        <div className="vertical-bottom-space">
          <TextField
            fullWidth
            id="description"
            name="description"
            type="string"
            label={t('mpConfig-form-description')}
            value={formik.values.description}
            onChange={formik.handleChange}
            error={formik.touched.description && Boolean(formik.errors.description)}
            helperText={formik.touched.description && formik.errors.description}
          />
        </div>
        <div className="vertical-bottom-space">
          <TextField
            fullWidth
            id="merchantId"
            name="merchantId"
            type="string"
            label={t('sitefConfig-form-merchantId')}
            value={formik.values.merchantId}
            onChange={formik.handleChange}
            error={formik.touched.merchantId && Boolean(formik.errors.merchantId)}
            helperText={formik.touched.merchantId && formik.errors.merchantId}
          />
        </div>
        <div className="vertical-bottom-space">
          <TextField
            fullWidth
            id="merchantKey"
            name="merchantKey"
            type="string"
            label={t('sitefConfig-form-merchantKey')}
            value={formik.values.merchantKey}
            onChange={formik.handleChange}
            error={formik.touched.merchantKey && Boolean(formik.errors.merchantKey)}
            helperText={formik.touched.merchantKey && formik.errors.merchantKey}
          />
        </div>
        <div className="vertical-bottom-space">
          <Button className="btn-50" color="primary" variant="contained" type="submit">
            {`${config ? t('save-config') : t('sitefConfig-form-config-create')} `}
          </Button>
        </div>
      </form>
    </div>
  );
};
